var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLocationIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "15px",
    height: "18px",
    viewBox: "0 0 15 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons / Location / Active") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Design",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Sidebar-/-Work-log-details",
    transform: "translate(-233.000000, -265.000000)",
    fill: "#5286F7",
    fillRule: "nonzero",
    stroke: "#5286F7",
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(25.000000, 227.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons-/-Location-/-Active",
    transform: "translate(209.000000, 39.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.38021638,0 C2.86862442,0 0,2.86862442 0,6.38021638 C0,8.6553323 1.0633694,11.0046368 3.11591963,13.2055641 C4.6244204,14.8377125 6.13292117,15.8021638 6.20710974,15.8516229 L6.38021638,16 L6.57805255,15.8763524 C6.65224111,15.8268934 8.13601236,14.812983 9.64451314,13.1561051 C11.6723338,10.9304482 12.7604328,8.60587326 12.7604328,6.4049459 C12.7604328,2.86862442 9.89180835,0 6.38021638,0 Z M6.38021638,15.0850077 C5.93508501,14.763524 4.77279753,13.9227202 3.63523957,12.6862442 C2.32457496,11.251932 0.741885626,9.0015456 0.741885626,6.38021638 C0.741885626,3.26429675 3.26429675,0.741885626 6.38021638,0.741885626 C9.49613601,0.741885626 12.0185471,3.26429675 12.0185471,6.38021638 C12.0185471,10.7326121 7.39412674,14.3431221 6.38021638,15.0850077 Z M6.38021638,3.58578053 C4.97063369,3.58578053 3.83307573,4.72333849 3.83307573,6.13292117 C3.83307573,7.54250386 4.97063369,8.70479134 6.38021638,8.70479134 C7.78979907,8.70479134 8.92735703,7.56723338 8.92735703,6.1576507 C8.92735703,4.74806801 7.78979907,3.58578053 6.38021638,3.58578053 Z M6.38021638,7.96290572 C5.39103555,7.96290572 4.57496136,7.14683153 4.57496136,6.1576507 C4.57496136,5.16846986 5.39103555,4.35239567 6.38021638,4.35239567 C7.36939722,4.35239567 8.18547141,5.16846986 8.18547141,6.1576507 C8.18547141,7.14683153 7.36939722,7.96290572 6.38021638,7.96290572 Z",
    id: "Shape"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIcon);
export default __webpack_public_path__ + "static/media/location-icon.f77c5fed55236d776d60f9a62fd9cd58.svg";
export { ForwardRef as ReactComponent };